







































import { Component, Vue } from 'vue-property-decorator';
import MobileDetectionMixin from '@/assets/ts/mobileDetectionMixin.ts';
import CertificateInformation from '@/components/certificate/CertificateInformation.vue';
import FlatButtonWithIcon from '@/components/FlatButtonWithIcon.vue';
import Alert from '@/components/Alert.vue';
import { EventBus } from '@/plugins/event-bus';
import baseAPI from '@/api/horizon-iium-luxtag/index';

@Component({
  components: {
    CertificateInformation,
    FlatButtonWithIcon,
    Alert,
  },
})
export default class CertificatePage extends MobileDetectionMixin {
  public isCertificateView = true;
  public certificatePayload: any = {};
  public isRevoked = false;
  public isMobile = false;
  public merchant = '';
  public data = {};
  public goHome() {
    this.$router.push('/');
  }
  public async created() {


    const params = new URLSearchParams(window.location.search);
    // const tokenValue = params.get('token');
    let currentUrl = window.location.pathname;
    currentUrl = currentUrl.replace('/', '');
    try {
      const res = await baseAPI
        .verify()
        .verifyCertificate(encodeURIComponent(currentUrl));

      if (res.data.institution_code) {
        this.merchant = res.data.institution_code;
      }
      if (res.verifiedByAuthority) {
        this.certificatePayload = res.data;
        this.isRevoked = res.data.revoked;
        this.$store.commit('MUTATE_PAYLOAD', res.data);
      } else {
        this.$router.push('/page-not-found');
      }
    } catch (err) {
      this.$router.push('/page-not-found');

      currentUrl = '';
    } finally {
      this.$store.commit('MUTATE_LOADER', false);
    }

    // check if the payload is there
    const payload = this.$store.getters.getPayload;
    if (!payload) {
      this.$router.push('/page-not-found');
    } else {
      // mount the data
      if (payload.payload) {
        if (payload.issuer) {
          this.certificatePayload = {
            issuer: payload.issuer,
            data: JSON.parse(payload.payload),
            verified: payload.verified,
            imgSrc: `${process.env.VUE_APP_BASE_API}/diploma/${payload.address}.png`,
          };
        } else {
          this.certificatePayload = {
            issuer: payload.institution_code,
            data: JSON.parse(payload.payload),
            verified: payload.verified,
            imgSrc: `${process.env.VUE_APP_BASE_API}/diploma/${payload.address}.png`,
          };
        }
      } else {
        this.certificatePayload = {
          issuer: payload.institution_code,
          verified: payload.verified,
          imgSrc: `${process.env.VUE_APP_BASE_API}/diploma/${payload.address}.png`,
        };
      }
    }
  }

  public beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: any) => {
      // access to component instance via `vm`
      EventBus.$emit('change-hide-slider', true);
      EventBus.$emit('change-show-tab-active-color', false);
    });
  }

  public beforeRouteLeave(to: any, from: any, next: any) {
    EventBus.$emit('change-hide-slider', false);
    EventBus.$emit('change-show-tab-active-color', true);
    next();
  }

  public certificateBtnClicked() {
    this.isCertificateView = true;
  }

  public detailsBtnClicked() {
    this.isCertificateView = false;
  }

  get clickedPage() {
    if (this.isCertificateView) {
      return true;
    } else if (!this.isCertificateView) {
      this.isCertificateView = false;
    }
  }
  get desktop() {
    if (!this.isMobile) {
      return true;
    }
  }

  get type() {
    return 'error';
  }

  get showArrow() {
    if (this.isRevoked) {
      return false;
    } else if (this.isExpired) {
      return true;
    }
  }

  get title() {
    if (this.isRevoked) {
      return 'This certificate has been revoked';
    } else if (this.isExpired) {
      return `This certificate expired on ${new Date(Number(this.certificatePayload.data.exp)).toLocaleDateString()}`;
    }
  }
  get description() {
    if (this.isRevoked) {
      return '';
    } else if (this.isExpired) {
      return `Contact ${process.env.VUE_APP_CLIENT_NAME} for assistance`;
    }
  }
  get isExpired() {
    return this.certificatePayload.data ? new Date(Number(this.certificatePayload.data.exp)) < new Date() : false;
  }
  get revoked() {
    if (this.isRevoked !== undefined) {
      return this.isRevoked;
    }
    return false;
  }
}
